import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { api } from '@/lib/api';
import { Search } from 'lucide-react';

export default function AdminBrands() {
    const [brands, setBrands] = useState([]);
    const [q, setQ] = useState('');

    useEffect(() => { api.get('/admin/brands').then(({ data }) => setBrands(data)); }, []);

    const filtered = brands.filter((b) => !q || b.name.toLowerCase().includes(q.toLowerCase()));

    return (
        <AdminLayout>
            <div className="p-10" data-testid="admin-brands-page">
                <div className="flex items-end justify-between mb-8">
                    <div>
                        <div className="overline">Brands</div>
                        <h1 className="font-serif text-4xl text-navy mt-2">Brand Directory</h1>
                    </div>
                    <div className="flex items-center gap-2 bg-white border border-border-subtle px-4 py-2 w-72">
                        <Search size={16} className="text-text-tertiary" />
                        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search brand…" className="flex-1 outline-none text-sm" data-testid="admin-brands-search" />
                    </div>
                </div>
                <div className="bg-white border border-border-subtle">
                    <table className="w-full text-sm">
                        <thead className="bg-cream text-text-tertiary text-xs uppercase tracking-widest">
                            <tr><th className="text-left p-4">Brand</th><th className="text-left p-4">Category</th><th className="text-left p-4">Malls</th><th className="text-left p-4">Earn Rate</th><th className="text-left p-4">Tags</th></tr>
                        </thead>
                        <tbody>
                            {filtered.map((b) => (
                                <tr key={b.id} className="border-t border-border-subtle">
                                    <td className="p-4 flex items-center gap-3"><img src={b.logo_url} alt="" className="w-8 h-8 object-contain bg-cream" onError={(e) => e.target.style.visibility = 'hidden'} /> <span className="text-navy font-medium">{b.name}</span></td>
                                    <td className="p-4 capitalize">{b.category}</td>
                                    <td className="p-4">{b.mall_ids.length}</td>
                                    <td className="p-4 text-gold">{b.earn_rate}x</td>
                                    <td className="p-4 text-xs">{b.is_luxury && <span className="bg-gold text-white px-2 py-0.5 mr-1">LUXURY</span>}{b.is_featured && <span className="bg-navy text-white px-2 py-0.5">FEATURED</span>}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </AdminLayout>
    );
}
